module.exports = __webpack_public_path__ + "static/farmfr2-ff9acfb817ef49f8cd29ca144b256c67.png";